export default "__VITE_ASSET__QRDsPm5w__"